import Request from './Request';

/**
 * SPS-5480 A2 — Admin Tools → Curated Content.
 *
 * Every write here lands a decision row and an audit row server-side; nothing about the
 * review state is computed in the browser. The page asks, the API decides, the page
 * re-reads — so two maintainers working the queue at once see each other's decisions on
 * the next load rather than fighting over local state.
 */
const clean = (params = {}) => Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
);

export default class ContentReviewService {
    /** The review queue. `filters` mirrors the API: review_status, category, new_since_review, changed_since_review, q. */
    static async listDocuments(filters = {}) {
        const qs = new URLSearchParams(clean(filters)).toString();
        return Request.get(`/api/admin/content-review/documents${qs ? `?${qs}` : ''}`);
    }

    static async approve(id) {
        return Request.post(`/api/admin/content-review/documents/${id}/approve`, {});
    }

    /** A reason is required by the API, not just by the dialog. */
    static async exclude(id, reason) {
        return Request.post(`/api/admin/content-review/documents/${id}/exclude`, { reason });
    }

    static async reopen(id) {
        return Request.post(`/api/admin/content-review/documents/${id}/reopen`, {});
    }

    /**
     * Apply one decision to the whole filtered set.
     *
     * The FILTERS are sent, not the ids the browser happens to be showing: the server
     * re-resolves them, so a bulk action cannot act on a stale page of results.
     */
    static async bulk({ action, filters = {}, reason }) {
        return Request.post('/api/admin/content-review/documents/bulk', clean({
            action,
            reason,
            filters: clean(filters),
        }));
    }
}
